package com.essntl.core.settings.data.supabase.configuration

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class EmailValuesDto(
    val from: String,
    val bcc: String,
    @SerialName("reply_to")
    val replyTo: String,
)


@Serializable
data class WaypointTemplateValuesDto(
    val simple: String,
    val multi: String,
)
